<div
  #dropTarget
  class="drop-target"
  (dragenter)="dragOver($event)"
  (dragover)="dragOver($event)"
  (dragleave)="dragDone($event)"
  (drop)="filesDropped($event); dragDone($event)"
  [class]="'layout-' + layout"
>
  @if (layout !== 'button-only') {
    <mat-icon class="add-file-icon">library_add</mat-icon>
    <div class="text-container">
      @if (supportsDrag) {
        <div class="drag-text">
          @if (maxFiles === 1) {
            {{ descriptionText[0] | translate }}
          } @else {
            {{ descriptionText[1] | translate }}
          }
        </div>
      }
      <glxy-uploader-constraints-text
        [accept]="accept"
        [maxFiles]="maxFiles"
        [maxFileSize]="maxFileSize"
        [text]="hintText"
      />
    </div>
  }

  <button class="browse-button" mat-stroked-button type="button" (click)="browseForFiles()">
    @if (maxFiles === 1) {
      {{ buttonText[0] | translate }}
    } @else {
      {{ buttonText[1] | translate }}
    }
  </button>
</div>

<input
  #fileInput
  class="hidden-file-input"
  [attr.multiple]="!maxFiles || maxFiles > 1 ? '' : null"
  type="file"
  [accept]="accept"
  (change)="filesSelected($event)"
/>
